__turbopack_context__.v({
  "all": "names-page-module__pf-iWq__all",
  "allTitle": "names-page-module__pf-iWq__allTitle",
  "chips": "names-page-module__pf-iWq__chips",
  "generator": "names-page-module__pf-iWq__generator",
  "grid": "names-page-module__pf-iWq__grid",
  "groupItems": "names-page-module__pf-iWq__groupItems",
  "groupTitle": "names-page-module__pf-iWq__groupTitle",
  "lead": "names-page-module__pf-iWq__lead",
  "options": "names-page-module__pf-iWq__options",
  "page": "names-page-module__pf-iWq__page",
  "result": "names-page-module__pf-iWq__result",
  "resultCopied": "names-page-module__pf-iWq__resultCopied",
  "resultFamily": "names-page-module__pf-iWq__resultFamily",
  "resultName": "names-page-module__pf-iWq__resultName",
  "resultNickname": "names-page-module__pf-iWq__resultNickname",
  "resultNote": "names-page-module__pf-iWq__resultNote",
  "results": "names-page-module__pf-iWq__results",
  "species": "names-page-module__pf-iWq__species",
  "title": "names-page-module__pf-iWq__title",
});
